export const getApiErrorMessage = (error, fallbackMessage = "Something went wrong") => {
  return (
    error?.response?.data?.description ||
    error?.response?.data?.message ||
    error?.data?.description ||
    error?.message ||
    fallbackMessage
  );
};
